export enum TrackedListColumns {
    LIST_ID = "listId",
    NAME = "name",
    LAST_UPDATED = "lastUpdated",
    RECORDS = "records",
}
